import axios from 'axios';
import env from 'constants/env';
import { reidentificationTokenKey } from 'types/admin';

type Params = {
  key: string;
  value: string | number | boolean;
};

export const paramsSerializer = (params: Params) => {
  const serialized = Object.entries(params).reduce(
    (acc, [key, value], index) => `${acc}${index === 0 ? '' : '&'}${key}=${encodeURIComponent(value)}`,
    '',
  );
  return serialized;
};

export const client = axios.create({
  baseURL: env?.BASE_URI,
  withCredentials: true,
  paramsSerializer,
});

// Response interceptor for handling 401 errors
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Auth token invalid/expired, clear reidentification token and redirect
      localStorage.removeItem(reidentificationTokenKey);
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
